import React from 'react'

import { ErrorMessage } from '@/components/forms/ErrorMessage'
import { InfoTooltip } from '@/components/tooltips/InfoTooltip'
import { FormField } from '@/components/forms/FormField'
import { TextInput } from '@/components/forms/TextInput'

import { getFieldErrorMessage } from './formik.helpers'

/**
 * @import import { TextField } from '@/components/forms/formik'
 * @param {object} props
 * @param {string} [props.label] Field label; omitted renders no label row
 * @param {string} [props.description] Help text under the label, for what the operator must read
 * @param {React.ReactNode} [props.labelTooltip] Help text behind an InfoTooltip on the label, for optional reading
 * @param {string} [props.errorMessage] Overrides the Formik validation message
 * @param {boolean} [props.required] Marks the field required in the label
 */
export const TextField = ({
  label,
  errorMessage,
  field: { name, value, ...fieldProps },
  form: { touched, errors },
  description,
  labelTooltip,
  required,
  ...props
}) => {
  const error = getFieldErrorMessage({ errorMessage, errors, touched, name })

  return (
    <FormField required={required} error={Boolean(error)}>
      {label && (
        <label htmlFor={name}>
          {label}
          <InfoTooltip content={labelTooltip} />
        </label>
      )}
      {description && <div className="form-caption">{description}</div>}
      <TextInput
        data-testid={`textField-${name}`}
        id={name}
        name={name}
        value={value ?? ''}
        error={Boolean(error)}
        {...fieldProps}
        {...props}
      />
      {error && <ErrorMessage content={error} />}
    </FormField>
  )
}
